import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Atuação', href: '#atuacao' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Como Funciona', href: '#como-funciona' },
  { label: 'Contato', href: '#contato' },
];

const WA_LINK = 'https://wa.me/5511984333601?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20um%20especialista%20em%20direito%20imobili%C3%A1rio.';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/85 backdrop-blur-md shadow-sm'
          : 'bg-white shadow-sm'
      }`}
    >
      {/* Top tagline bar */}
      <div
        className="w-full text-center py-1.5 text-xs tracking-widest font-sans font-light"
        style={{ background: '#0A2A52', color: '#D4AF37' }}
      >
        Não se trata de uma questão de sorte.&nbsp;
        <span className="font-semibold" style={{ color: '#E5C76B' }}>
          É estratégia.
        </span>
      </div>

      <nav className="w-full px-6 md:px-12 py-4 flex items-center md:justify-between">
        {/* Invisible spacer — matches hamburger width so logo is truly centered on mobile */}
        <div className="w-10 h-10 flex-shrink-0 md:hidden" aria-hidden="true" />

        {/* Logo */}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="flex-1 md:flex-none flex justify-center md:justify-start cursor-pointer md:ml-[20px]"
        >
          <img
            src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/dd0808434e8d654dd901725d75cf786a.png"
            alt="Uitalo Bruno Advocacia"
            className="w-auto object-contain"
            style={{ height: '67px' }}
          />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="font-sans text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap"
                style={{ color: '#0A2A52' }}
                onMouseEnter={(e) => { (e.target as HTMLAnchorElement).style.color = '#D4AF37'; }}
                onMouseLeave={(e) => { (e.target as HTMLAnchorElement).style.color = '#0A2A52'; }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-sm text-sm font-semibold font-sans tracking-wide whitespace-nowrap transition-all duration-300 cursor-pointer"
          style={{ background: '#D4AF37', color: '#0A2A52' }}
          onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = '#C29B2E'; }}
          onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = '#D4AF37'; }}
        >
          <i className="ri-whatsapp-line text-base"></i>
          Falar no WhatsApp
        </a>

        {/* Hamburger */}
        <button
          className="md:hidden flex-shrink-0 w-10 h-10 flex items-center justify-center cursor-pointer"
          style={{ color: '#0A2A52' }}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menu"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
        style={{ background: '#ffffff' }}
      >
        <div className="px-6 pb-6 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="font-sans text-sm font-medium py-2 border-b cursor-pointer transition-colors duration-200 whitespace-nowrap"
              style={{ color: '#0A2A52', borderColor: 'rgba(10,42,82,0.15)' }}
            >
              {link.label}
            </a>
          ))}
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 flex items-center justify-center gap-2 px-5 py-3 text-sm font-semibold font-sans tracking-wide whitespace-nowrap cursor-pointer"
            style={{ background: '#D4AF37', color: '#0A2A52', borderRadius: '2px' }}
          >
            <i className="ri-whatsapp-line"></i>
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
}